import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    user: null
});

export const UserContext = ctx;

export const UserProvider = Provider;
